"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var Footer_1 = require("./Footer");
var LvFlowProgressBarWidget_1 = require("./progressBar/LvFlowProgressBarWidget");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var MotorProgressBarSettings_1 = require("./progressBar/MotorProgressBarSettings");
var RentersProgressBarSettings_1 = require("./progressBar/RentersProgressBarSettings");
var commonFunctions_1 = require("../commonFunctions");
var MaintenanceBannerWidget_1 = require("../widgets/MaintenanceBannerWidget");
var WolfMotorProgressBarSettings_1 = require("./progressBar/WolfMotorProgressBarSettings");
var AnnualHomeProgressBarSettings_1 = require("./progressBar/AnnualHomeProgressBarSettings");
var LvFalconNavigator = /** @class */ (function (_super) {
    __extends(LvFalconNavigator, _super);
    function LvFalconNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.skipDefault = function (event) {
            event.preventDefault();
        };
        _this.showProgressBar = true;
        _this.showBackground = true;
        _this.showLock = false;
        _this.showTitle = true;
        _this.isMotorProduct = services_1.productHelper.isMotor(_this.props.interaction);
        _this.isRentersProduct = services_1.productHelper.isRenters(_this.props.interaction);
        _this.isWolfProduct = services_1.productHelper.isWolfMotor(_this.props.interaction);
        _this.isHomeProduct = services_1.productHelper.isHome(_this.props.interaction);
        if (_this.isMotorProduct) {
            _this.progressBarSettings = new MotorProgressBarSettings_1.MotorProgressBarSettings();
        }
        else if (_this.isWolfProduct) {
            _this.progressBarSettings = new WolfMotorProgressBarSettings_1.WolfMotorProgressBarSettings();
        }
        else if (_this.isRentersProduct) {
            _this.progressBarSettings = new RentersProgressBarSettings_1.RentersProgressBarSettings();
        }
        else if (_this.isHomeProduct) {
            _this.progressBarSettings = new AnnualHomeProgressBarSettings_1.AnnualHomeProgressBarSettings();
        }
        _this.clickPrev = _this.clickPrev.bind(_this);
        _this.preClickNext = _this.preClickNext.bind(_this);
        _this.clickNext = _this.clickNext.bind(_this);
        _this.clickLogo = _this.clickLogo.bind(_this);
        return _this;
    }
    LvFalconNavigator.prototype.componentDidCatch = function (error, errorInfo) {
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "JRE: exception: ".concat(error.message ? error.message : "", "\n    Interaction id: ").concat(this.props.interaction._id || "-", "\n    Product: ").concat(this.props.product || "-", "\n    Process: ").concat(this.props.process || "-", "\n    Page: ").concat(this.props.page && this.props.page.pageId, "\n    ComponentStack: ").concat(errorInfo.componentStack || "-", "\n    Stack: ").concat(error.stack || "-")
        }, false).subscribe();
    };
    LvFalconNavigator.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var pageTitleClassName = ((_a = this.props.page) === null || _a === void 0 ? void 0 : _a.pageId) === 'quote' ? 'quote-title' : '';
        var stickyPricePresent = (_b = this.props.page) === null || _b === void 0 ? void 0 : _b.questions.some(function (e) { var _a; return e.type === "stickyPrice" || e.type === "annualHomeStickyPrice" || ((_a = e.questions) === null || _a === void 0 ? void 0 : _a.some(function (e) { return e.type === "annualHomeStickyPrice"; })); });
        var stickyPricePadding = stickyPricePresent && this.showProgressBar ? " padding-top-80-not-important" : "";
        return (React.createElement(React.Fragment, null,
            this.showBackground && (React.createElement("div", { className: "journey-bg" },
                React.createElement("div", null,
                    React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }),
                    React.createElement("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" })))),
            this.mapInteractionToDataLayer(),
            this.renderHeader(),
            this.renderProgressBar(),
            React.createElement("div", { className: "journey-content".concat(stickyPricePadding) },
                React.createElement("div", { className: "journey-questions" },
                    this.showTitle && (React.createElement("div", { className: "journey-questions-title" }, (((_c = this.props.page) === null || _c === void 0 ? void 0 : _c.pageId) !== "decline") && (this.props.process === 'nb' || this.props.process.startsWith("mta")) &&
                        React.createElement(React.Fragment, null,
                            this.showLock ? React.createElement("h1", { className: pageTitleClassName },
                                React.createElement("span", { className: "secure-payment-icon" }, (_d = this.props.page) === null || _d === void 0 ? void 0 : _d.title)) : React.createElement("h1", { className: pageTitleClassName }, (_e = this.props.page) === null || _e === void 0 ? void 0 : _e.title),
                            React.createElement(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product })))),
                    React.createElement("div", { className: "journey-questions-body" },
                        React.createElement("div", { className: "journey-questions-body-content" }, this.props.children))),
                (this.props.page && (this.props.page.nextPage || this.props.page.prevPage)) &&
                    React.createElement("div", { className: "journey-buttons" },
                        React.createElement("div", { className: "journey-buttons-content" },
                            this.renderNextButton(),
                            this.renderBackButton()))),
            this.renderFooter()));
    };
    LvFalconNavigator.prototype.clickPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickPrev.call(this)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.engine.validate()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.preClickNext = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.target.focus();
                        return [4 /*yield*/, this.clickNext()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickNext.call(this)];
                    case 1:
                        _c.sent();
                        if ((0, commonFunctions_1.isPageValid)(this.props.pageValidations, this.props.validations)) {
                            this.props.engine.setJourneyState((_a = {},
                                _a["hidePageValidationErrorMessage"] = true,
                                _a["hideUnansweredWarning"] = true,
                                _a));
                        }
                        else {
                            this.props.engine.setJourneyState((_b = {},
                                _b["hidePageValidationErrorMessage"] = false,
                                _b["hideUnansweredWarning"] = false,
                                _b));
                        }
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickLogo = function () {
        window.location.href = "/dashboard";
    };
    LvFalconNavigator.prototype.renderBackButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return (React.createElement("button", { type: "button", role: "link", className: "btn btn-back", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack" }, this.props.page && this.props.page.prevPageLabel ? this.props.page.prevPageLabel : "Back"));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderNextButton = function () {
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.nextPage) {
            var withoutBackButtonCssClass = this.isBackButtonExists() ? "" : " btn-next-without-back-button";
            var cssClasses = "btn btn-primary" + (this.isNextButtonEnabled() ? "" : " btn-disabled") + " btn-next-arrow-separate btn-next-mobile-margin" + withoutBackButtonCssClass;
            return (React.createElement("button", { type: "button", className: cssClasses, onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.preClickNext, id: "navigatorNext" },
                this.props.page && this.props.page.nextPageLabel ? this.props.page.nextPageLabel : "Next",
                React.createElement("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderProgressBar = function () {
        if (!this.showProgressBar) {
            return React.createElement(React.Fragment, null);
        }
        var percentageByPageId = this.progressBarSettings ? this.progressBarSettings.getPercentageByPageId(this.props.page.pageId) : null;
        if (percentageByPageId === null) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(LvFlowProgressBarWidget_1.default, { percentage: percentageByPageId });
    };
    LvFalconNavigator.prototype.renderHeader = function () {
        return (React.createElement("div", { className: "journey-header" },
            React.createElement("div", { className: "journey-header-background" },
                React.createElement("a", { className: "header-logo-link", id: "goToAllianzHomePage", href: "https://www.allianz.co.uk", target: "_blank", "aria-label": "Link to Allianz home page" },
                    React.createElement("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo icon"), tabIndex: 0 })))));
    };
    LvFalconNavigator.prototype.renderFooter = function () {
        return React.createElement(Footer_1.Footer, null);
    };
    LvFalconNavigator.prototype.mapInteractionToDataLayer = function () {
        var _a;
        if (this.props.interaction) {
            var policyHolder = this.props.interaction.policyHolder ? this.props.interaction.policyHolder : null;
            var address = policyHolder && policyHolder.address ? policyHolder.address : null;
            var factors = this.props.interaction.factors ? this.props.interaction.factors : null;
            var underwritingResult = this.props.interaction.underwritingResult && this.props.interaction.underwritingResult.length > 0 ? this.props.interaction.underwritingResult[0] : null;
            var vehicleCount = this.props.interaction.vehicles ? this.props.interaction.vehicles.length : 0;
            var startDate = this.props.interaction.headerInfo ? moment(this.props.interaction.headerInfo.startDate).format("DD/MM/YYYY") : null;
            var realEstate = this.props.interaction.realEstate && this.props.interaction.realEstate[0] ? this.props.interaction.realEstate[0] : null;
            var valuableItems = this.props.interaction.valuableItems ? this.props.interaction.valuableItems : null;
            var paymentDay = this.props.interaction.paymentDay ? this.props.interaction.paymentDay : null;
            var additionalDrivers = this.props.interaction.additionalDrivers && this.props.interaction.additionalDrivers.length > 0 ? this.props.interaction.additionalDrivers : null;
            window.LvDataLayer = {
                screenResolution: window.innerWidth + "x" + window.innerHeight,
                pageTitle: this.props.page.title,
                previousPageTitle: this.props.page.prevPage,
                partner: "lv",
                employmentStatus: policyHolder && policyHolder.employmentStatus ? this.fetchLookupValue("employmentStatus", policyHolder.employmentStatus) : null,
                maritalStatus: policyHolder && policyHolder.maritalStatus ? this.fetchLookupValue("maritalStatus", policyHolder.maritalStatus) : null,
                ukResidency: policyHolder ? policyHolder.residencyLength : null,
                ownsHome: policyHolder && policyHolder.ownsHome != null ? (policyHolder.ownsHome ? "Yes" : "No") : null,
                claimsIndicated: policyHolder && policyHolder.hasClaims != null ? (policyHolder.hasClaims ? "Y" : "N") : null,
                convictionsIndicated: policyHolder && policyHolder.hasConvictions !== null ? (policyHolder.hasConvictions ? "Yes" : "No") : null,
                yearOfBirth: policyHolder && policyHolder.dateOfBirth ? this.extractYearFromDate(policyHolder.dateOfBirth) : null,
                emailAddress: policyHolder ? policyHolder.email : null,
                postCode: address ? address.outwardPostcode : null,
                numberOfDrivers: this.isMotorProduct ? this.getNumberOfDrivers(this.props.interaction) : null,
                totalPricePerMonth: factors ? factors.premium : null,
                priceRange: !this.isWolfProduct ? this.getPriceRange(factors) : null,
                quoteReference: this.props.interaction._id,
                marketingPreferenceEmail: policyHolder ? (policyHolder.marketingPreferencesEmail ? "Y" : "N") : null,
                marketingPreferencePhone: policyHolder ? (policyHolder.marketingPreferencesPhone ? "Y" : "N") : null,
                marketingPreferencePost: policyHolder ? (policyHolder.marketingPreferencesPost ? "Y" : "N") : null,
                marketingPreferenceSms: policyHolder ? (policyHolder.marketingPreferencesSMS ? "Y" : "N") : null,
                policyReference: this.props.interaction.agreementNumber,
                failedUwRule: underwritingResult ? underwritingResult.objectName : null,
                vehicles: this.getVehicleData(),
                numberOfCars: vehicleCount,
                multipleCars: this.isMotorProduct ? (vehicleCount > 1 ? "Y" : "N") : null,
                documentMethod: policyHolder && policyHolder.sendDocumentsByPost ? "Post" : "Email",
                startingProduct: this.getDataLayerProduct(),
                coverStartDate: startDate,
                liveAlone: realEstate ? (realEstate.hasNoOtherResidents ? "Y" : "N") : null,
                homeClaimsIndicated: this.isRentersProduct ? (this.hasHomeClaims() ? "Y" : "N") : null,
                propertyType: realEstate && this.getTypeOrKindOfProperty(realEstate, true),
                kindOfProperty: realEstate && this.getTypeOrKindOfProperty(realEstate, false),
                numberOfFamilyMembers: realEstate && realEstate.adultFamilyMemberCount,
                numberOfHousemates: realEstate && realEstate.housemateCount,
                gotKids: realEstate ? (realEstate.childrenAtProperty ? "Y" : "N") : null,
                typeOfTenancy: realEstate && realEstate.furnishingType && this.fetchLookupValue("furnishingType", realEstate.furnishingType),
                numberOfBedrooms: realEstate && realEstate.bedroomCount ? realEstate.bedroomCount : null,
                numberOfBathrooms: realEstate && realEstate.bathroomCount ? realEstate.bathroomCount : null,
                includedItemsWorthMoreThan2K: valuableItems ? ((0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems) > 2000 ? "Y" : "N") : null,
                wantCoverAwayFromHome: this.isRentersProduct ? (this.hasCoverAnywhere() ? "Y" : "N") : null,
                coverLimit: this.isRentersProduct && factors ? factors.insuredValue : null,
                accidentalDamageToContents: this.isRentersProduct && factors ? (factors.accidentalDamageProtection ? "Y" : "N") : null,
                homeExcess: this.isRentersProduct && factors ? factors.excessAmount : null,
                homeStartDate: this.isRentersProduct ? startDate : null,
                licenceHandy: this.isWolfProduct && policyHolder ? policyHolder.drivingLicenceHandy : null,
                title: this.isWolfProduct && policyHolder ? policyHolder.title : null,
                firstName: policyHolder ? policyHolder.firstName : null,
                lastName: policyHolder ? policyHolder.lastName : null,
                dln: policyHolder && policyHolder.licence != null ? policyHolder.licence.number : null,
                licenceType: ((_a = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.licence) === null || _a === void 0 ? void 0 : _a.type) ? this.fetchLookupValue("drivingLicenceTypes", policyHolder.licence.type.toString()) : null,
                licenceHeldYears: this.isWolfProduct && policyHolder && policyHolder.drivingExperience ? this.fetchLookupValue("drivingExperienceOpts", policyHolder.drivingExperience.toString()) : null,
                occupation: this.isWolfProduct && policyHolder && policyHolder.occupation ? this.fetchLookupValue("wolfOccupation", policyHolder.occupation) : null,
                occupationIndustry: this.isWolfProduct && policyHolder && policyHolder.occupationIndustry ? this.fetchLookupValue("wolfOccupationIndustry", policyHolder.occupationIndustry) : null,
                hasSecondaryOccupation: this.isWolfProduct && policyHolder ? (policyHolder.hasSecondaryOccupation ? "Y" : "N") : null,
                secondaryOccupation: this.isWolfProduct && policyHolder && policyHolder.secondaryOccupation ? this.fetchLookupValue("wolfOccupation", policyHolder.secondaryOccupation) : null,
                numberOfClaims: policyHolder ? policyHolder.numberOfClaims : null,
                ukResidentOver3Years: this.isWolfProduct && policyHolder ? (policyHolder.residentOfUKMoreThanThreeYears ? "Y" : "N") : null,
                residencyTerm: this.isWolfProduct && policyHolder && policyHolder.residencyTerm ? this.fetchLookupValue("residencyTerms", policyHolder.residencyTerm.toString()) : null,
                nonMotoringConvictions: policyHolder && policyHolder.hasUnspentCriminalConvictions != null ? (policyHolder.hasUnspentCriminalConvictions ? "Y" : "N") : null,
                ncdYears: this.isWolfProduct && policyHolder && policyHolder.ncd ? policyHolder.ncd.yearCount : null,
                ncdEarningType: this.isWolfProduct && policyHolder && policyHolder.ncd && policyHolder.ncd.earningType ? this.fetchLookupValue("ncdEarnType", policyHolder.ncd.earningType.toString()) : null,
                protectedNcd: this.isWolfProduct && policyHolder && policyHolder.ncd ? (policyHolder.ncd.doNotDisclose ? "Y" : "N") : null,
                carsInHousehold: policyHolder ? policyHolder.carsInHousehold : null,
                paymentOption: this.isWolfProduct && factors ? factors.premiumType : null,
                coverType: this.isWolfProduct ? "COMPREHENSIVE" : null,
                automaticRenewal: this.isWolfProduct && policyHolder ? policyHolder.automaticRenewal : null,
                aggregatorName: this.populateAggregatorInfo(this.props.interaction),
                paymentDay: paymentDay ? paymentDay.day : null,
                addDriver: !this.isRentersProduct ? (additionalDrivers ? "Y" : "N") : null,
                annualPremium: this.isWolfProduct && factors ? factors.annualPremium : null,
                externalWallMaterial: realEstate && realEstate.externalWallMaterial ? this.fetchLookupValue("wallMaterial", realEstate.externalWallMaterial) : null,
                roofMaterial: realEstate && realEstate.roofMaterial ? this.fetchLookupValue("roofMaterial", realEstate.roofMaterial.toString()) : null,
                yearBuilt: realEstate && realEstate.yearBuilt ? realEstate.yearBuilt : null,
                propertyListing: realEstate && realEstate.propertyListing ? this.fetchLookupValue("propertyListing", realEstate.propertyListing) : null,
                isMainHome: realEstate && realEstate.isMainHome != null ? (realEstate.isMainHome ? "Y" : "N") : null,
                residentsType: realEstate && realEstate.residentsType ? this.fetchLookupValue("residencyUsage", realEstate.residentsType) : null,
                numberOfChildren: realEstate && realEstate.numberOfChildren ? realEstate.numberOfChildren : null,
                isLeftEmpty: realEstate && realEstate.isLeftEmpty != null ? (realEstate.isLeftEmpty ? "Y" : "N") : null,
                ownershipType: realEstate && realEstate.ownershipType ? this.fetchLookupValue("propertyOwnershipType", realEstate.ownershipType) : null,
                yearsAtProperty: policyHolder ? policyHolder.yearsAtProperty : null,
                homePolicyHolderTitle: policyHolder && policyHolder.title ? this.fetchLookupValue("homePolicyHolderTitle", policyHolder.title) : null,
                hasJointPolicyHolder: policyHolder && policyHolder.hasJointPolicyHolder != null ? (policyHolder.hasJointPolicyHolder ? "Y" : "N") : null,
                monthlyPaymentAvailable: this.props.interaction.paymentDetails ? (this.props.interaction.paymentDetails.instalmentPlan && this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters ? "Y" : "N") : null,
                documentsByEmail: policyHolder && policyHolder.sendDocumentsByPost ? "N" : "Y",
                homeAnnualPremium: this.isHomeProduct && factors ? factors.annualPremium : null,
                homeCoverLevel: this.isHomeProduct ? this.props.interaction.coverLevel : null,
                homeCoverTier: this.isHomeProduct ? this.props.interaction.coverTier : null,
                homeFixedAddonsBuildingAccidentalDamage: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.buildingAccidentalDamage ? "Y" : "N") : null,
                homeFixedAddonsContentsAccidentalDamage: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.contentsAccidentalDamage ? "Y" : "N") : null,
                homeFixedAddonsHomeEmergency: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.homeEmergency ? "Y" : "N") : null,
                homeFixedAddonsHomeLegalExpenses: this.isHomeProduct && this.props.interaction.annualHomeFixedAddons ? (this.props.interaction.annualHomeFixedAddons.homeLegalExpenses ? "Y" : "N") : null,
                coverTier: this.props.interaction.coverTier
            };
        }
    };
    LvFalconNavigator.prototype.populateAggregatorInfo = function (interaction) {
        var aggregatorName;
        var line;
        if (this.isWolfProduct && interaction.source) {
            switch (interaction.source) {
                case 'ctm':
                    aggregatorName = 'CTM';
                    break;
                case 'cnf':
                    aggregatorName = 'CONF';
                    break;
                case 'msm':
                    aggregatorName = 'MSM';
                    break;
                case 'gc':
                    aggregatorName = 'GOCO';
                    break;
                default:
                    return null;
            }
            line = "LVCar/Aggregator/".concat(aggregatorName);
            if (interaction.clickthroughTier) {
                line += '/' + interaction.clickthroughTier;
            }
            return line;
        }
        if (this.isHomeProduct && interaction.source) {
            switch (interaction.source) {
                case 'ctmhome':
                    aggregatorName = 'CTM';
                    break;
                case 'cnfhome':
                    aggregatorName = 'CONF';
                    break;
                case 'msmhome':
                    aggregatorName = 'MSM';
                    break;
                case 'gchome':
                    aggregatorName = 'GOCO';
                    break;
                default:
                    return null;
            }
            line = "LVHome/Aggregator/".concat(aggregatorName);
            if (interaction.clickthroughTier) {
                line += '/' + interaction.clickthroughTier;
            }
            return line;
        }
        return null;
    };
    LvFalconNavigator.prototype.isBackButtonExists = function () {
        if (!this.props.page) {
            return false;
        }
        return this.props.page.prevPage != null;
    };
    LvFalconNavigator.prototype.isNextButtonEnabled = function () {
        return !this.props.page.nextPageButtonCondition ||
            journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, this.props.page.nextPageButtonCondition, this.props.interaction);
    };
    LvFalconNavigator.prototype.extractYearFromDate = function (date) {
        return moment(date, moment.ISO_8601).year();
    };
    LvFalconNavigator.prototype.getNumberOfDrivers = function (interaction) {
        if (interaction.policyHolder) {
            if (interaction.additionalDrivers) {
                return interaction.additionalDrivers.length + 1;
            }
            else {
                return 1;
            }
        }
        return null;
    };
    LvFalconNavigator.prototype.getPriceRange = function (factors) {
        if (factors) {
            return factors.neverLower + "-" + factors.neverHigher;
        }
        return null;
    };
    LvFalconNavigator.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    LvFalconNavigator.prototype.getVehicleData = function () {
        var _this = this;
        var vehicleInfo = [];
        if (this.props.interaction.vehicles) {
            var optionalExtras_1 = this.props.interaction.optionalExtras;
            this.props.interaction.vehicles.forEach(function (vehicle) {
                var legalProtection = optionalExtras_1 ? (optionalExtras_1.motorLegalExpenses ? "Y" : "N") : null;
                var courtesyCar = optionalExtras_1 ? (optionalExtras_1.courtesyCar ? "Y" : "N") : null;
                var courtesyCarTotalLoss = _this.setValueOrNull(optionalExtras_1, function () { return _this.getYN(optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLoss); });
                var car = {
                    yearOfManufacture: vehicle.year,
                    fuelType: vehicle.fuelType ? _this.fetchLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)) : null,
                    fuelTypeFull: vehicle.fuelTypeFull ? vehicle.fuelTypeFull : null,
                    make: vehicle.make,
                    model: vehicle.model,
                    voluntaryExcess: _this.getVoluntaryExcess(vehicle),
                    courtesyCar: courtesyCar,
                    motorLegalExpensesCost: legalProtection ? optionalExtras_1.motorLegalExpensesCost : null,
                    motorLegalExpenses: legalProtection,
                    courtesyCarCost: courtesyCar ? optionalExtras_1.courtesyCarCost : null,
                    courtesyCarTotalLoss: courtesyCarTotalLoss,
                    courtesyCarTotalLossCost: _this.setValueOrNull(courtesyCarTotalLoss, function () { return optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarTotalLossCost; }),
                    totalPricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.grossPremium : null,
                    pricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.roundedPremium : null,
                    regNumberProvided: vehicle.manuallyChosen != null ? (vehicle.manuallyChosen ? "N" : "Y") : null,
                    vrn: vehicle.registrationNumber,
                    transmission: vehicle.transmission ? _this.fetchLookupValue("vehicleTransmission", vehicle.transmission) : null,
                    modifications: vehicle.hasModifications != null ? (vehicle.hasModifications ? "Y" : "N") : null,
                    trackerInstalled: _this.isWolfProduct && vehicle.trackerQuestionRequired ? (vehicle.trackerInstalled ? "Y" : "N") : null,
                    mileage: vehicle.mileage ? _this.fetchLookupValue("mileage", vehicle.mileage.toString()) : null,
                    carUsage: _this.isWolfProduct && vehicle.classOfUse ? _this.fetchLookupValue("carUsage", vehicle.classOfUse) : null,
                    breakdownCover: optionalExtras_1 ? (optionalExtras_1.breakdownCover ? "Y" : "N") : null,
                    breakdownCoverType: optionalExtras_1 && optionalExtras_1.breakdownCoverLevel ? optionalExtras_1.breakdownCoverLevel : null,
                    familyPackage: optionalExtras_1 ? (optionalExtras_1.familyPackage ? "Y" : "N") : null
                };
                vehicleInfo.push(car);
            });
        }
        return vehicleInfo;
    };
    LvFalconNavigator.prototype.getYN = function (value) {
        return value ? "Y" : "N";
    };
    LvFalconNavigator.prototype.setValueOrNull = function (condition, valueAccessor) {
        return condition != null ? valueAccessor() : null;
    };
    LvFalconNavigator.prototype.hasHomeClaims = function () {
        return this.props.interaction.claims && this.props.interaction.claims.length > 0 &&
            this.props.interaction.claims.some(function (c) { return c.claimType >= 10; });
    };
    LvFalconNavigator.prototype.getTypeOrKindOfProperty = function (realEstate, type) {
        var estateTypeSubType = realEstate.realEstateTypeSubType ? this.fetchLookupValue("realEstateTypeSubType", realEstate.realEstateTypeSubType) : null;
        if (estateTypeSubType) {
            var lastWord = estateTypeSubType.split(" ").pop();
            return lastWord ? (type ? lastWord.charAt(0).toUpperCase() + lastWord.substring(1, lastWord.length) : estateTypeSubType.replace(lastWord, "").trim()) : null;
        }
        return null;
    };
    LvFalconNavigator.prototype.hasCoverAnywhere = function () {
        return this.props.interaction.valuableItems && this.props.interaction.valuableItems.length > 0 && this.props.interaction.valuableItems.some(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE; });
    };
    LvFalconNavigator.prototype.getVoluntaryExcess = function (vehicle) {
        if (this.isMotorProduct && vehicle.excesses) {
            return vehicle.excesses.voluntaryExcess;
        }
        else if (this.isWolfProduct && vehicle.annualVehicleExcess) {
            return vehicle.annualVehicleExcess.voluntaryExcess;
        }
        return null;
    };
    LvFalconNavigator.prototype.getDataLayerProduct = function () {
        if (this.isMotorProduct) {
            return "Motor Subscription";
        }
        else if (this.isRentersProduct) {
            return "Renters";
        }
        else if (this.isWolfProduct) {
            return "Motor Annual";
        }
        return null;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "journeyRuntimeService", void 0);
    return LvFalconNavigator;
}(plugin_journey_1.NavigatorWidgetBase));
exports.default = LvFalconNavigator;
//# sourceMappingURL=LvFalconNavigator.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/navigator/LvFalconNavigator.js
// module id = 239
// module chunks = 0